import theme from '../base'

const link = {
  MuiLink: {
    defaultProps: {
      type: 'button',
      underline: 'hover',
    },
    styleOverrides: {
      root: {
        // TODO: pending from design
        fontFamily: 'ActoMedium',
        fontSize: 14,
        fontWeight: 500,

        color: theme.palette.primary.main,
        cursor: 'pointer',

        '&:focus-visible': {
          color: theme.palette.primary.dark,
        },

        '&:disabled': {
          color: theme.palette.neutral.light,
          pointerEvents: 'none',
        },

        '&.linkBack': {
          display: 'flex',
          '& .linkBack-icon': {
            width: theme.spacing(2),
            height: theme.spacing(2),
          },
          '&::after': {
            left: theme.spacing(2),
          },
          '&:hover': {
            '&::after': {
              width: `calc(100% - ${theme.spacing(2)})`,
            },
          },
        },

        '&.linkCode': {
          color: theme.palette.neutral.main,
          fontFamily: 'Arial, sans-serif',
          fontSize: 12,
          fontWeight: 700,

          '&:hover': {
            color: theme.palette.primary.main,
          },
        },
      },

      underlineHover: {
        display: 'inline-block',
        position: 'relative',

        '&::after': {
          content: "''",
          position: 'absolute',
          bottom: -1,
          left: 0,
          height: 1,
          width: theme.spacing(1.5),
          backgroundColor: theme.palette.primary.main,
          transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
        },

        '&:hover': {
          textDecoration: 'none',

          '&::after': {
            width: '100%',
          },
        },

        '&:disabled': {
          '&::after': {
            width: 0,
          },
        },
      },
    },
  },
}

export default link
